import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editPortalSettingModal } from '../../../../actions/modal.js';
import { setSelectedPortalSettingValue, updatePortalSetting } from '../../../../actions/portalSetting';
import Info from '../../info';

export default function RightPanelEditPortalSetting(props) {
  const dispatch = useDispatch();
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const [onApiCallDisableResetButton, setOnApiCallDisableResetButton] = useState(false);
  const selectedPortalSettingValue = useSelector((state) => state.portalSettingReducer.selectedPortalSettingValue);

  const closeModal = () => {
    dispatch(setSelectedPortalSettingValue({}));
    dispatch(editPortalSettingModal(false));
    props.setResetButtonTriggerValueChange(false);
  };
  const handleResetButton = () => {
    props.setResetButtonTriggerValueChange(!props.resetButtonTriggerValueChange);
    props.setLatestValueSaveChange(selectedPortalSettingValue.defaultValue);
  };
  const handleEditValueSaveChanges = () => {
    setSaveButtonLoading(true);
    setOnApiCallDisableResetButton(true);
    dispatch(updatePortalSetting({ name: selectedPortalSettingValue?.name, value: props.latestValueSaveChange }));
    // props.setResetButtonTriggerValueChange(false);
  };

  let resetButtonClass =
    'ui approve labeled icon button icon left-text reset-button reset-button-hover mrrxs color-white max-width mrlnull mrbnull';
  let saveClasses =
    'ui approve labeled icon button icon left-text color-button color-button-hover mrrxs color-white max-width mrtm mrlnull mrbnull';

  return (
    <div className="right-panel">
      <div className=" mrbs max-width mrtxxs">
        <button
          type="button"
          onClick={() => handleResetButton()}
          className={!props.resetButtonTriggerValueChange ? resetButtonClass : resetButtonClass + ' disable'}
          disabled={props.resetButtonTriggerValueChange || onApiCallDisableResetButton}
          data-group="editPortalSettingFormGroup"
        >
          {APP.LANGUAGE.ResetToDefaultSmallCase}
          <i className="undo icon " />
        </button>
        <button
          tabIndex="2"
          type="button"
          onClick={() => handleEditValueSaveChanges()}
          className={saveButtonLoading ? saveClasses + ' loading' : saveClasses}
          data-group="editPortalSettingFormGroup"
        >
          {APP.LANGUAGE.UserProfile.SaveChanges}
          <i className="checkmark icon " />
        </button>

        <button
          onClick={closeModal}
          type="button"
          className="ui cancel labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
      <Info paragraphs={[APP.LANGUAGE.AdminMenu.PortalSettingModalPartOneInfo]} />
    </div>
  );
}
